import { Menu, Text, UnstyledButton } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type TrackedSuggestion = {
  key: string;
  textContent: string;
  scrollIntoView: () => void;
};

type AreasEditedSummaryProps = {
  editCount: number;
  suggestions: TrackedSuggestion[];
};

export default function AreasEditedSummary({ editCount, suggestions }: AreasEditedSummaryProps) {
  const areaText = editCount === 1 ? '1 area' : `${editCount} areas`;

  return (
    <Text size="textMd" fw={FONT_WEIGHTS.semibold} c="white">
      <Menu position="top">
        <Menu.Target>
          <UnstyledButton
            style={{
              textDecoration: 'underline',
              textDecorationStyle: 'dotted',
              textUnderlineOffset: 2,
              color: 'white',
              fontWeight: FONT_WEIGHTS.semibold,
              fontSize: 'var(--mantine-font-size-textMd)',
            }}
          >
            {areaText}
          </UnstyledButton>
        </Menu.Target>
        <Menu.Dropdown maw={350}>
          {suggestions.length === 0 ? (
            <Menu.Item disabled>No edits</Menu.Item>
          ) : (
            suggestions.map(suggestion => {
              const truncatedText =
                suggestion.textContent.length > 50
                  ? `${suggestion.textContent.slice(0, 50)}...`
                  : suggestion.textContent;
              return (
                <Menu.Item key={suggestion.key} onClick={suggestion.scrollIntoView}>
                  <Text size="sm" fw={FONT_WEIGHTS.medium} c="black">
                    {truncatedText}
                  </Text>
                </Menu.Item>
              );
            })
          )}
        </Menu.Dropdown>
      </Menu>{' '}
      edited by Siesta AI
    </Text>
  );
}
